import * as Sentry from '@sentry/browser';
import {Vue as VueIntegration, Offline as OfflineIntegration } from '@sentry/integrations';
import Vue from "vue";

const environment = document.head.querySelector('meta[name="environment"]');
const release = document.head.querySelector('meta[name="release"]');
const dsn = document.head.querySelector('meta[name="sentry-dsn"]');

if(dsn && dsn.content) {
    Sentry.init({
        dsn: dsn.content,
        environment: (environment?.content ?? 'local') + '-JS',
        release: release?.content,
        integrations: [
            new VueIntegration({
                Vue,
                attachProps: true,
                logErrors: true,
            }),
            new OfflineIntegration(),
        ],
    });
}
